import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import MotionEffects from "./components/feature/MotionEffects";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";
import { AuthProvider } from "./contexts/AuthContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <MotionEffects />
          <AppRoutes />
          <FloatingWhatsApp />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
